import axios from "../../config/axiosConfig";
import {
  GST_LEDGER_REPORT_REQUEST,
  GST_LEDGER_REPORT_SUCCESS,
  GST_LEDGER_REPORT_FAILURE,
} from "../types/gst-ledger-report-types";

export const getGstLedgerReport = (params) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: GST_LEDGER_REPORT_REQUEST });

      const { auth } = getState();
      const defaultParams = {
        // finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth.user?.Customer_Id,
        ...params
      };
      // Merge default params with provided params
      const requestParams = { ...defaultParams };
      // Log the request parameters
      console.log('Request Param Datas >>>>>', requestParams);
      // Construct the complete URL with query parameters
      const queryString = new URLSearchParams(requestParams).toString();
      const fullUrl = `/gst-ledger-report/getReport?${queryString}`;
      // Log the full URL (to debug)
      console.log('>>Complete API Request URL: ', fullUrl);
      // Make API call
      return axios.get(fullUrl).then((response) => {
        console.log('<<<Purchase API Response Data: ', response);
        // Dispatch success action with data
        if (response.data) {
          dispatch({ type: GST_LEDGER_REPORT_SUCCESS, payload: response.data });
        }
      }).catch((error) => {
        console.error("Error fetching reverse gst charge Report:", error);
        dispatch({ type: GST_LEDGER_REPORT_FAILURE, error: error.message });
      });
    } catch (error) {
      console.error("Error fetching reverse gst charge Report:", error);
      dispatch({ type: GST_LEDGER_REPORT_FAILURE, error: error.message });
    }
  };
};

export const clearGstLedgerReport = () => {
  return async (dispatch) => {
        dispatch({ type: GST_LEDGER_REPORT_SUCCESS, payload: {} });
  }
}
